import { useEffect, useState } from 'react';
import { Loader, PropertyCard } from '../../components';
import { useCollection } from '../../hooks';
import { Filter } from './components';
import './Discover.scss';

const Discover = () => {
  const [filterSettings, setFilterSettings] = useState({});
  const [properties, setProperties] = useState();
  const { documents, error } = useCollection('properties', undefined, [
    'createdAt',
    'desc',
  ]);

  useEffect(() => {
    setProperties(documents);
  }, [documents]);

  useEffect(() => {
    if (documents) {
      setProperties((prevProperties) => {
        let docs = [];
        if (!filterSettings.city) {
          docs = documents.filter((p) => true);
        } else {
          docs = documents.filter(
            (p) => filterSettings.city === p.location.city
          );
        }

        if (!filterSettings.propertyName) {
          docs = docs.filter((p) => true);
        } else {
          docs = docs.filter((p) =>
            p.name.includes(filterSettings.propertyName)
          );
        }

        if (!filterSettings.minPrice) {
          docs = docs.filter((p) => true);
        } else {
          docs = docs.filter((p) => filterSettings.minPrice <= p.maxPrice);
        }

        if (!filterSettings.maxPrice) {
          docs = docs.filter((p) => true);
        } else {
          docs = docs.filter((p) => filterSettings.maxPrice >= p.minPrice);
        }

        if (!filterSettings.propertyType) {
          docs = docs.filter((p) => true);
        } else {
          docs = docs.filter((p) =>
            p.propertyTypes.includes(filterSettings.propertyType)
          );
        }

        if (!filterSettings.beds) {
          docs = docs.filter((p) => true);
        } else {
          docs = docs.filter((p) => filterSettings.beds <= p.maxBeds);
        }

        if (!filterSettings.baths) {
          docs = docs.filter((p) => true);
        } else {
          docs = docs.filter((p) => filterSettings.beds <= p.maxBaths);
        }

        if (!filterSettings.minSize) {
          docs = docs.filter((p) => true);
        } else {
          docs = docs.filter((p) => filterSettings.minSize <= p.maxSize);
        }

        if (!filterSettings.maxSize) {
          docs = docs.filter((p) => true);
        } else {
          docs = docs.filter((p) => filterSettings.maxSize >= p.maxSize);
        }

        return docs;
      });
    }
    // eslint-disable-next-line
  }, [filterSettings]);

  const search = (params) => {
    setFilterSettings(params);
  };

  return (
    <div className="discover">
      <div className="discover__gallery">
        <h2 className="title">Discover</h2>
        {error && <div className="error">{error}</div>}
        {properties ? (
          <div className="properties">
            {properties.map((property) => (
              <PropertyCard
                key={property.id}
                id={property.id}
                name={property.name}
                cardPicURL={property.cardPicURL}
                location={property.location}
                unit={property.unitType[0]}
                currency={property.currency}
              />
            ))}
          </div>
        ) : (
          <Loader abs={true} />
        )}
      </div>
      <Filter search={search} />
    </div>
  );
};

export default Discover;
